export default "__VITE_ASSET__BCSKBHPl__"